import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['No sabés por dónde empezar ni qué herramienta elegir para emprender', 'Sin un método claro, pasás meses aprendiendo sin saber cuándo estás listo para cobrar', 'Sin protocolo de consulta, cada sesión es improvisada y el cliente lo percibe', 'Sin ficha profesional, tu servicio no transmite seriedad ni confianza', 'Sin saber cuánto cobrar, regalás tu tiempo o directamente no arrancás', 'Sin estrategia de primeros clientes, todo queda en intención y no en acción', 'Sin saber fabricar el péndulo, perdés una fuente de ingresos extra sin darte cuenta', 'Cada semana pasa y el emprendimiento sigue siendo un sueño postergado'];
  return <Section className="max-w-4xl" data-id="element-358">
      <div className="text-center mb-12" data-id="element-359">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-plum" data-id="element-360">
          ¿Cuánto tiempo más vas a buscar cómo emprender sin encontrar el
          camino?
        </h2>
        <p className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-361">
          Querés generar tus propios ingresos desde casa. No depender de un
          jefe, no tener horarios fijos y sabes que hay algo en el mundo
          energético y espiritual que te llama. Pero nadie te mostró un camino
          concreto. Uno que te enseñe una herramienta real, te diga cómo usarla,
          cómo estructurar un servicio y cómo cobrar por él desde el primer mes.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-purple mt-6 font-serif italic" data-id="element-362">
          No es falta de ganas. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-brand-surfaceLight/70 border-brand-purple/20" data-id="element-363">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-plum text-base md:text-lg" data-id="element-364">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-365" /> Lo que
          pasa sin el Kit:
        </h3>
        <ul className="space-y-4" data-id="element-366">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-367">
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-368" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-369">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-370">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-371">
          ¿Y si esta fuera la última semana que postergás tu emprendimiento?
        </h3>
      </div>
    </Section>;
};